import KKPromo from "@/public/KinoklubbKnappEksternekinosider.svg";
import classNames from "classnames";
import Link from 'next/link';
import styles from "./KinoklubbTicket.module.css";


//#region [Props]
export type KinoklubbTicketProps = {
    className?: string;
};
//#endregion

//#region [Component]
export default function KinoklubbTicket({ className }: KinoklubbTicketProps) {
    return <Link href={process.env.NEXT_PUBLIC_KINOKLUBB_INFO_URL as string} passHref target="_blank" legacyBehavior>
        <a className={classNames(styles.KinoklubbTicket, className)}>
            <div className={styles.Promo}>
                <KKPromo role="img" alt="Se filmen til halv pris med Filmweb Kinoklubb. Klikk her for å lese mer og bli medlem." />
            </div>
        </a>
    </Link>;
}
//#endregion
